module.exports = __webpack_public_path__ + "video/400_KMSAT15_2022_Cybercrime_Strategies-Malware.b339c657.vtt";